import { render, staticRenderFns } from "./ImageTabs.vue?vue&type=template&id=548e2930"
import script from "./ImageTabs.vue?vue&type=script&lang=js"
export * from "./ImageTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports